/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TierType = "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type UpdateCompanySubscriptionInput = {|
  plan?: ?string,
  coupon?: ?string,
  currency?: ?string,
  virtualSeats?: ?number,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type updateCompanySubscriptionMutationVariables = {|
  input: UpdateCompanySubscriptionInput
|};
export type updateCompanySubscriptionMutationResponse = {|
  +updateCompanySubscription: ?{|
    +company: ?{|
      +id: string,
      +tier: ?TierType,
      +coupon: ?string,
      +subscription: ?{|
        +planId: ?string,
        +nextAmountDue: ?number,
        +nextPaymentDateDay: ?number,
        +nextPaymentDateMonth: ?number,
        +nextPaymentDateYear: ?number,
        +seatPrice: ?number,
        +billingPeriodType: ?string,
        +billingPeriod: ?number,
      |},
    |}
  |}
|};
export type updateCompanySubscriptionMutation = {|
  variables: updateCompanySubscriptionMutationVariables,
  response: updateCompanySubscriptionMutationResponse,
|};
*/


/*
mutation updateCompanySubscriptionMutation(
  $input: UpdateCompanySubscriptionInput!
) {
  updateCompanySubscription(input: $input) {
    company {
      id
      tier
      coupon
      subscription {
        planId
        nextAmountDue
        nextPaymentDateDay
        nextPaymentDateMonth
        nextPaymentDateYear
        seatPrice
        billingPeriodType
        billingPeriod
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCompanySubscriptionInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tier",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coupon",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextAmountDue",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextPaymentDateDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextPaymentDateMonth",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nextPaymentDateYear",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seatPrice",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingPeriodType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingPeriod",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCompanySubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanySubscriptionPayload",
        "kind": "LinkedField",
        "name": "updateCompanySubscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCompanySubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCompanySubscriptionPayload",
        "kind": "LinkedField",
        "name": "updateCompanySubscription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "subscription",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCompanySubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation updateCompanySubscriptionMutation(\n  $input: UpdateCompanySubscriptionInput!\n) {\n  updateCompanySubscription(input: $input) {\n    company {\n      id\n      tier\n      coupon\n      subscription {\n        planId\n        nextAmountDue\n        nextPaymentDateDay\n        nextPaymentDateMonth\n        nextPaymentDateYear\n        seatPrice\n        billingPeriodType\n        billingPeriod\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0111a9f26c204f4d634ef229ccee9b07';

module.exports = node;
